import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import '../news.css';
import API from '../api';
import { useAuth } from '../AuthContext';

const News_Management = () => {
  const [rows, setRows] = useState([]);
  const { user, loading } = useAuth();
  const [publishChannel, setPublishChannel] = useState('telegram'); // default to telegram

  useEffect(() => {
  if (loading) return; // wait for auth

  const fetchNews = async () => {
    try {
      const res = await API.get('/api/news');
      console.log(res.data);

      // Map 'status' from backend to 'published' boolean
      const data = res.data.map(item => ({
        ...item,
        published: item.status === 1, // published = true if status === 1
      }));

      setRows(data);
    } catch (err) {
      console.error('Error fetching news:', err);
    }
  };

  fetchNews();
}, [user, loading]);


  const handleChange = (id, field, value) => {
    setRows(rows.map(row => (row.id === id ? { ...row, [field]: value } : row)));
  };

  const handleUpdate = async () => {
    const rowsToUpdate = rows.filter(row => row.published);
    if (rowsToUpdate.length === 0) {
      alert('No rows selected for update!');
      return;
    }

    try {
      for (const row of rowsToUpdate) {
        await API.post(`/api/news/${row.id}`, row);
      }
      alert('Selected rows updated successfully!');
    } catch (err) {
      console.error(err);
      alert('Failed to update selected rows.');
    }
  };


const handlePublish = async () => {
    // const updated = rows.map(row => ({ ...row, published: true }));
    // setRows(updated);
    // alert('All rows marked as published. Now click Update to save changes.');

  const selectedIds = rows
    .filter(row => row.published)
    .map(row => row.id);

  if (selectedIds.length === 0) {
    alert('No news items selected for publishing.');
    return;
  }

  const idString = selectedIds.join(',');

  try {
    const res = await API.post('/api/publish-news', {
      ids: idString,
      channel: publishChannel  
    });

    alert(res.data.message || 'News published successfully!');
  } catch (err) {
    console.error('Publish error:', err);
    alert('Failed to publish news.');
  }
};


  if (loading) return <div>Loading...</div>;

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div className="table-container">
        <h2>News Management</h2>
        <table className="stock-news-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Stock Name</th>
              <th>Title</th>
              <th>News</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>
                  <input
                    type="text"
                    value={row.stock_name}
                    onChange={e => handleChange(row.id, 'stock_name', e.target.value)}
                    className="stock-input"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.title}
                    onChange={e => handleChange(row.id, 'title', e.target.value)}
                    className="title-input"
                  />
                </td>
                <td>
                  <textarea
                    value={row.news}
                    onChange={e => handleChange(row.id, 'news', e.target.value)}
                    rows={4}
                    className="news-textarea"
                  />
                </td>
                <td>{new Date(row.create_date).toLocaleString()}</td>
                <td className="checkbox-cell">
                  <input
                    type="checkbox"
                    checked={row.published}
                    onChange={e => handleChange(row.id, 'published', e.target.checked)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
              <div className="button-group">
  <div className="channel-select">
    <label htmlFor="channel">Publish Channel:</label>
    <select
      id="channel"
      value={publishChannel}
      onChange={(e) => setPublishChannel(e.target.value)}
      className="channel-dropdown"
    >
      <option value="telegram">Telegram</option>
      <option value="sms">SMS</option>
    </select>
  </div>
  <button className="publish-btn" onClick={handlePublish}>Publish Selected</button>

  <button className="update-btn" onClick={handleUpdate}>Update Selected</button>
</div>

      </div>
    </div>
  );
};

export default News_Management;